'use client';

import { Dropdown } from 'antd';
import { EvimoButton } from '~/app/components/common/EvimoButton/EvimoButton';
import { MoreOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { TableRowActionItem } from '~/app/components/common/TableRowActionsMenu/types';
import {
  handleTableRowActionMenuClick,
  toAntTableRowActionMenuItems,
} from '~/app/components/common/TableRowActionsMenu/utils';

export type TableRowActionsMenuProps = {
  items: TableRowActionItem[];
  ariaLabel?: string;
  loading?: boolean;
};

/**
 * Standard row actions control for tables: ⋮ menu (always), even for a single action.
 */
export function TableRowActionsMenu({
  items,
  ariaLabel,
  loading = false,
}: TableRowActionsMenuProps) {
  const { t } = useTranslation('common');

  if (items.length === 0) {
    return null;
  }

  const label = ariaLabel ?? t('tableActions.more', 'More actions');

  return (
    <div
      className="evimo-table-row-actions-wrap"
      onClick={(event) => event.stopPropagation()}
    >
      <Dropdown
        trigger={['click']}
        overlayClassName="evimo-table-row-actions-dropdown"
        getPopupContainer={() => document.body}
        menu={{
          items: toAntTableRowActionMenuItems(items),
          onClick: handleTableRowActionMenuClick(items),
        }}
      >
        <EvimoButton
          type="text"
          size="small"
          className="evimo-table-row-actions"
          iconLeft={<MoreOutlined />}
          aria-label={label}
          loading={loading}
          onClick={(event) => event.stopPropagation()}
        />
      </Dropdown>
    </div>
  );
}
